import React, { useState, useEffect } from "react";
import FileUpload from "../FileUpload/FileUpload";
const RichMediaUpload = ( actionList ) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  console.log(actionList.payload[0].payload);

  const handleFileSelect = (file) => {
    setUploadedFile(file);
    console.log("Uploaded File:", file);
  };

  const buttonText = actionList.payload[0].text;
  return (
    <div style={{ margin: "10px", padding: "10px", backgroundColor: "#e5e5ea", textAlign: "left" }}>
    <h3 style={{ marginBottom: "20px" }}>Please upload your deposit slip</h3>
      <FileUpload onFileSelect={handleFileSelect} />
    </div>
  );
};
export default RichMediaUpload;
